export default __webpack_public_path__ + "static/media/pod-1.92010dd4.jpg";